import { Link } from "react-router-dom";

const stats = [
  { value: "18", label: "收录剧集", icon: "ri-film-line" },
  { value: "9.2", label: "最高评分", icon: "ri-star-line" },
  { value: "300+", label: "演员资料", icon: "ri-user-star-line" },
  { value: "9", label: "资讯专题", icon: "ri-newspaper-line" },
];

export default function SiteIntro() {
  return (
    <section className="bg-background-200/50">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 py-12 md:grid-cols-2 md:px-8 md:py-16">
        <div className="flex flex-col justify-center">
          <p className="font-label text-[11px] tracking-[0.3em] text-accent-600">ABOUT THE SITE</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            专注“出轨的味道”的影视内容门户
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            “出轨的味道”影视内容站致力于为剧迷提供清晰、完整的内容索引。我们围绕该主题影视剧，整理了全集信息、分集概要、详细剧情介绍、演员资料及最新相关资讯，
            让你不必在零散的信息里反复查找。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            无论你是第一次接触这个系列，还是追了三年的老观众，都可以在这里快速找到想要了解的内容。站内的剧集目录与相关推荐均为内容展示演示，
            不提供播放与下载服务。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/category"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 cursor-pointer"
            >
              <i className="ri-grid-line text-lg"></i>
              浏览影视分类
            </Link>
            <Link
              to="/about"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-700 cursor-pointer"
            >
              <i className="ri-information-line text-lg"></i>
              了解关于我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 self-center">
          {stats.map((item) => (
            <div key={item.label} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <p className="mt-4 font-label text-2xl font-semibold text-foreground-950">{item.value}</p>
              <p className="mt-1 text-xs text-foreground-600">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}